import React from "react";
import { Document, Page } from "react-pdf";
import { connect } from "react-redux";
import "./PDFViewer.css";
import pdfjsLib from "pdfjs-dist";
import LineReader from "../line-reader/line-reader";
import lineReaderIcon from "../../assets/images/line-reader-icon-white.png";
import { toggleReader } from "../line-reader/line-reader-manager";

// Point to the worker in public folder
pdfjsLib.PDFJS.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;
class PDFViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      pageNumber: 1,    
      scale: 1.2,  // default zoom = 100%
    };

    this.onDocumentLoad = this.onDocumentLoad.bind(this);
    this.onDocumentError = this.onDocumentError.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.goToPrevPage = this.goToPrevPage.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.toggleReaderFunction = this.toggleReaderFunction.bind(this);
  }

  onDocumentLoad({ numPages }) {
    console.log("PDF loaded with", numPages, "pages");
    this.setState({ numPages });
  }

  onDocumentError(error) {
    console.error("Error loading PDF", error);
  }
  goToPrevPage = () => {
    this.setState((state) => ({
      pageNumber: Math.max(state.pageNumber - 1, 1),
    }));
  };

  goToNextPage = () => {
    this.setState((state) => ({
      pageNumber: Math.min(state.pageNumber + 1, state.numPages),
    }));
  };
  
  zoomIn = () => {
    console.log("Zoom In");
    
    this.setState(state => ({ scale: state.scale + 0.2 }));
  };

  zoomOut = () => {
    this.setState(state => ({ scale: Math.max(state.scale - 0.2, 0.2) }));
  };

  toggleReaderFunction() {
    toggleReader();
  }

  render() {
    const { url, name, showLineReader } = this.props;
    const { pageNumber, numPages, scale} = this.state;
    return (
      <div className="pdf-viewer-wrapper">
        {showLineReader &&<LineReader></LineReader>}

        <div className="pdf-viewer-container">
        {url ? (
              <Document
                file={url}
                onLoadSuccess={this.onDocumentLoad}
                onLoadError={this.onDocumentError}
                loading={<div>Loading PDF...</div>}
              >
                {numPages &&
                  Array.from(new Array(numPages), (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      scale={scale}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  ))
                }
                {
                  // numPages && (
                  // <Page
                  //   key={`page_${pageNumber}`}
                  //   pageNumber={pageNumber}
                  //   scale={scale}
                  //   renderTextLayer={false}
                  //   renderAnnotationLayer={false}
                  // />)
              }
              </Document>
        ) : (
          <p>No PDF URL provided.</p>
        )}
        </div>

        <div className="pdf-nav-bar">
        {
        //  <button onClick={this.goToPrevPage} disabled={pageNumber <= 1}>
        //     Prev
        //   </button>
        //   <span>
        //     Page {pageNumber} of {numPages || "–"}
        //   </span>
        //   <button onClick={this.goToNextPage} disabled={pageNumber >= numPages}>
        //     Next
        //   </button>
        }
          <button onClick={this.zoomOut}>-</button>
          {showLineReader && (
            <button onClick={this.toggleReaderFunction} style={{
              height: '70%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '10px',
              flexDirection: 'column',
              paddingTop: '9px'
            }}>
              <img src={lineReaderIcon} alt="Line Reader" className="line-reader-icon" height="100%" /> 
              Line Reader
            </button>
          )}
          <button onClick={this.zoomIn}>+</button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state };
}

export default connect(mapStateToProps)(PDFViewer);
